/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, {useState, useEffect, useCallback} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCalendar, faCheck, faCog, faEye, faHandHolding, faHandLizard, faHome, faPhone, faSearch, faSync, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup, Dropdown, Card, Table, Badge} from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from "react-redux"
import NewBundleSheetPage from "./NewBundleSheetPage";
import BundleAction from "../../core/redux/action/BundleAction";
import AppConfig from "../../core/config/AppConfig";
const moment = require('moment');
import PuPagination from "../../components/PuPagination"
import BundleSheetDetailPage from "./BundleSheetDetailPage";
import { currencyFormat, nameFormat, phoneFormat } from "../../core/util/General";
import Swal from 'sweetalert2'
import Datetime from "react-datetime";

export default (props) => {

  const [reference, setReference] = useState()
  const [status, setStatus] = useState()
  const [accountNo, setAccountNo] = useState()
  const [barcode, setBarcode] = useState()

  const [isNew, setIsNew] = useState()
  const dispatch = useDispatch();
  const bundleRes = useSelector((state) => state.bundle);
  //const waybills = _.get(waybillRes, "waybillList.data");
  const pages = _.get(bundleRes, "bundleList.pages");
  const size = _.get(bundleRes, "bundleList.size");
  const total = _.get(bundleRes, "bundleList.total");
  const [currentPage, setCurrentPage] = useState();
  const [serviceType, setServiceType] = useState();
  const [createDateFrom, setCreateDateFrom] = useState();
  const [createDateTo, setCreateDateTo] = useState();

  const [id, setId] = useState()

  const keyPressFunction = useCallback((event) => {
    if (event.keyCode === 13) {
        fetchData()
    }
  }, [props, status, barcode, accountNo, reference,]);

useEffect(() => {
    document.addEventListener("keydown", keyPressFunction, false);
    return () => {
        document.removeEventListener("keydown", keyPressFunction, false);
    };
}, [keyPressFunction]);

  useEffect(()=>{
    if(_.get(bundleRes, 'bundleList.data') == undefined) fetchData()
  }, [])

  useEffect(() => {
    if(currentPage != undefined) fetchData()
  }, [currentPage])

  const fetchData = () => {    
    dispatch(BundleAction.getBundleList({
      input : {
        status,
        barcode,
        accountNo: accountNo ? `JOONAAK-${accountNo}` : undefined,
        reference,
        serviceType,
        createDateFrom,
        createDateTo
      },
      token : ""
    }, {
      size: AppConfig.pageSize,
      sort: "createdAt,DESC",
      page: currentPage
    }));
  };

  const updatedStatus = (item, status) => {
    dispatch(BundleAction.updateBundleStatus({
      input : {
        status, id: _.get(item, 'id')
      },
      token : ""
    }));
  }

  const focousOut = (value) => {
    if(!moment(value).isValid()) {
     setCreatedAt(undefined)
    }
  }

  if (isNew) {
    return (
      <NewBundleSheetPage onClose={(timer) => {
        setIsNew(undefined)
        timer && clearInterval(timer)
      }} />
    )
  }

  if(id) {
    return (
      <BundleSheetDetailPage id={id} 
        onClose={(timer) => {
          setId(undefined)
          timer && clearInterval(timer)
        }}        
      />
    )
  }

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">          
          <h4>Bundle Sheet</h4>          
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm" onClick={()=>{setIsNew(true)}}>New</Button>
            <Button variant="outline-primary" size="sm">Export</Button>
          </ButtonGroup>
        </div>
      </div>

      <Card>

        <Card.Header>
          <Row>
            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    //console.log('>value', e.target.value)                        
                    setStatus(e.target.value == "--All--" ? undefined : e.target.value)
                  }}>
                    <option>--All--</option>
                    <option>Created</option>
                    <option>Received</option>                                      
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            
            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Barcode#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faBarcode} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => setBarcode(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Account No</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faUserShield} />
                  </InputGroup.Text>
                  <Form.Control required type="text"
                    onChange={(e) => { setAccountNo(e.target.value == '' ? undefined : e.target.value) }} />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Reference#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faBarcode} />
                  </InputGroup.Text>
                  <Form.Control required type="text"
                    onChange={(e) => setReference(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Service Type</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    setServiceType(e.target.value == "--All--" ? undefined : e.target.value)
                  }}>
                    <option>--All--</option>
                    <option value="joonaak">Joonaak</option>
                    <option value="pickup">Pickup</option>
                    <option value="express">Express</option>
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4 float-end" style={{ paddingTop: 30 }}>
                <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
              </Form.Group>
            </Col>
          </Row>      
          <Row>
            <Col xs={12} sm={2} xl={2}>
                <Form.Group className="mb-4">
                  <Form.Label>Created From Date</Form.Label>
                  <Datetime
                      timeFormat
                      onChange={setCreateDateFrom}         
                      locale={'UTC+07'}             
                      renderInput={(props, openCalendar) => (
                          <InputGroup>
                              <InputGroup.Text>
                                <FontAwesomeIcon icon={faSync} onClick={()=>{                                    
                                    setCreateDateFrom()                                    
                                  }}/>
                              </InputGroup.Text>
                              <Form.Control                                                                    
                                  type="text"
                                  value={createDateFrom ?  moment(createDateFrom).format("MM-DD-YYYY") : ''}
                                  onChange={(e)=>{console.log("d change", e)}}
                                  placeholder="MM-DD-YYYY"                                  
                                  onFocus={openCalendar} />
                          </InputGroup>
                      )} />
              </Form.Group>              
            </Col>
            <Col xs={12} sm={2} xl={2}>
                <Form.Group className="mb-4">
                  <Form.Label>Created To Date</Form.Label>
                  <Datetime
                      timeFormat
                      closeOnSelect
                      onChange={setCreateDateTo}                         
                      renderInput={(props, openCalendar) => (
                          <InputGroup>
                              <InputGroup.Text>
                                <FontAwesomeIcon icon={faSync} onClick={()=>{setCreateDateTo(undefined)}}/>
                              </InputGroup.Text>
                              <Form.Control                                                                    
                                  type="text"
                                  value={createDateTo ?  moment(createDateTo).format("MM-DD-YYYY") : ''}
                                  placeholder="MM-DD-YYYY"                                  
                                  onFocus={openCalendar} />
                          </InputGroup>
                      )} />
              </Form.Group>   
              </Col>   
                      
          </Row>    
        </Card.Header>        
        
        <Card.Body>
          <Row>
            <Table responsive className="table-centered table-nowrap rounded mb-0">
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>                     
                    <th className="border-0">Date</th>
                    <th className="border-0">Arrived Date</th>
                    <th className="border-0">Item#</th>                    
                    <th className="border-0">Account No</th>                    
                    <th className="border-0">Service Type</th> 
                    <th className="border-0">Total Price</th>
                    <th className="border-0" align="center">Status</th>
                    <th className="border-0">Item Count</th>                    
                  </tr>
                </thead>
                <tbody>
                {
                  _.get(bundleRes, 'bundleList.data') && (
                    _.get(bundleRes, 'bundleList.data').map((item, index) =>{
                      return <tr>
                        <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>                                                
                        <td>{moment(_.get(item, 'createdAt')).format('MM-DD-YYYY')}</td>
                        <td align="center">{_.get(item, 'arrivedAt', '') ? moment(_.get(item, 'arrivedAt', '')).format('MM-DD-YYYY') : ''}</td>
                        <td align="left">{_.get(item, 'barcode', '')}</td>

                        <td>
                          {_.get(item, 'receiver.accountNo', '')}
                          <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ nameFormat(_.get(item, 'receiver')) }</small>
                          <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ phoneFormat(_.get(item, 'receiver')) }</small>                        
                        </td>
                        <td align="left">{_.get(item, 'serviceType', '')}</td>
                        <td align="left">{ currencyFormat(_.get(item, 'totalFee', '')) }</td>
                        <td align="left">                          
                          {
                            _.get(item, 'status') == 'Created' && (
                              <Button className={'btn-sm btn-warning'} onClick={()=>{
                                Swal.fire({
                                  title: 'Good Received?',                                  
                                  showCancelButton: true,
                                  confirmButtonText: `Yes`,
                                  type: 'warning'
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    updatedStatus(item, 'Received')
                                  }
                                })                                
                              }}>
                              <FontAwesomeIcon icon={faHandLizard}/> &nbsp;Receive</Button>                          
                            )
                          }
                          {
                            _.get(item, 'status') == 'Received' && (
                              <Button className={'btn-sm btn-success'}>Received</Button>                          
                            )
                          }
                        </td>
                        <td align="left">
                          <Button className={'btn-sm'} onClick={()=>{setId(_.get(item, 'id'))}}><FontAwesomeIcon icon={faEye}/> &nbsp;{_.get(item, 'itemCount', '')}</Button>                          
                        </td>
                      </tr>
                    })
                  )
                }
                </tbody>
            </Table>
          </Row>
        </Card.Body>
        <Card.Footer>
          <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage} />
        </Card.Footer>
      </Card>
      
    </>
  );
};


export const BundleStatus = ({item}) => {  
  switch(_.get(item, 'status')) {
    case "Created" : return <Badge pill bg='warning' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case 'Received': return <Badge pill bg='success' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>    
  }    
}